import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const canonical = document.getElementById('canonical-url') as HTMLLinkElement | null
if (canonical) canonical.href = `${window.location.origin}/`

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
